import moment from 'moment'

import { useSelector } from '@tabeeb/store'
import { Stack, Caption, Tooltip } from '@collaborate-health/uikit'
import { PluginUser } from '@tabeeb/modules/../users/types'
import { getUserById } from '@tabeeb/modules/../users/selectors'
import { FormAnswerStatus } from '@tabeeb/contracts/main-api/swagger-main-api'

import { FormControlAnswer } from '../../types'

import { AnswererUserAvatar } from './FormQuestionAnswerer.styled'

export interface FormQuestionAnswererProps {
  answer: FormControlAnswer
}

const FormQuestionAnswerer: React.FC<FormQuestionAnswererProps> = ({ answer }) => {
  const user = useSelector<PluginUser | undefined>((state) => getUserById(state, { Id: answer.UserId }))
  if (!user || answer.FormAnswerStatus === FormAnswerStatus.Empty) {
    return null
  }

  return (
    <Tooltip
      cursor='help'
      title={user.displayName}
      text={`On ${moment(answer.CreatedOn).format('DD/MM/YYYY [at] h:mm A')}`}
    >
      <Stack direction='row' alignItems='center' spacing={1}>
        <AnswererUserAvatar user={user} />
        <Caption fontWeight={500} color='textPrimary' noWrap maxWidth={125}>
          {user.displayName}
        </Caption>
      </Stack>
    </Tooltip>
  )
}

export default FormQuestionAnswerer

